import React, { Component } from "react";

import styles from "./ResumeBox.css";
import Profile from "./Profile/Profile";
import Tabs from "./Tabs/Tabs";
import Resume from "./Resume/Resume";
import Portfolio from "./Portfolio/Portfolio";
import Contact from "./Contact/Contact";
import Aux from "../../hoc/Aux";
import resumeDetails from "../../assets/resume";

class ResumeBox extends Component {
  state = {
    display: {
      profile: true,
      resume: false,
      portfolio: false,
      contact: false
    },
    profileInfo: {
      firstName: resumeDetails.firstName,
      lastName: resumeDetails.lastName,
      fullName: resumeDetails.fullName,
      positionHeadline: resumeDetails.positionHeadline,
      quote: resumeDetails.quote,
      quoteAuthor: resumeDetails.quoteAuthor,
      contact: resumeDetails.contact
    },
    resumeInfo: {
      summary: resumeDetails.summary,
      workHistory: resumeDetails.workHistory,
      educationHistory: resumeDetails.educationHistory,
      skills: resumeDetails.skills,
      interests: resumeDetails.interests
    }
  };

  changeDisplayHandler = targetType => {
    const { display } = this.state;
    const clearDisplay = {
      profile: false,
      resume: false,
      portfolio: false,
      contact: false
    };
    const newDisplay = { ...clearDisplay };
    if (display[targetType]) {
      return;
    }
    this.setState({ display: clearDisplay });
    newDisplay[targetType] = true;
    setTimeout(() => {
      this.setState({ display: newDisplay });
    }, 525);
  };

  render() {
    const { display, profileInfo, resumeInfo } = this.state;
    return (
      <Aux>
        <div className={styles.Container}>
          <Profile display={display.profile} details={profileInfo} />
          <Tabs tabClick={this.changeDisplayHandler} />
          <Resume display={display.resume} details={resumeInfo} />
          <Portfolio display={display.portfolio} />
          <Contact display={display.contact} />
        </div>
      </Aux>
    );
  }
}

export default ResumeBox;



// WEBPACK FOOTER //
// ./src/containers/ResumeBox/ResumeBox.js